import { TransactionAmount } from './TransactionAmount';
import { Chip } from '@heroui/react';
import type { SalesTransactionDiscount } from '@/api/models';

type TransactionDiscountChipProps = {
    discount: SalesTransactionDiscount;
    scope: 'line' | 'sale';
};

export const TransactionDiscountChip = ({
    discount,
    scope,
}: TransactionDiscountChipProps) => (
    <Chip color="warning" variant="primary" size="sm">
        <Chip.Label>
            {discount.type === 'percentage' ? (
                <>
                    {scope === 'line' ? '−' : ''}
                    {discount.value}%
                </>
            ) : (
                <TransactionAmount
                    amountTetri={discount.valueTetri ?? discount.amountTetri}
                    minus
                />
            )}
        </Chip.Label>
    </Chip>
);
